import { LookupDto } from "../../app/model/api/types/dto";

export const getRole = (roleId: string | null, roles: LookupDto[]) =>
  roles?.find(
    (role: LookupDto) => role.id?.toLowerCase() === roleId?.toLowerCase()
  ) ?? null;
